import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import { Button, FormControl, FormHelperText, Input, InputLabel, Modal, Box, Snackbar, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MarkdownView from 'react-showdown';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import TwitterIcon from '@mui/icons-material/Twitter';
import { verifyTwitterFollower } from "../../../commands/verifyTwitterFollower";
import CircularProgress from '@mui/material/CircularProgress'
import { getWalletAddress, updateQuestsLs } from '../../../commands/localStoreCommand';

//
export function TwitterQuestModal(props: any) {
    const [twAnchor, setTwAnchor] = useState<string>("");
    const [reqStatus, setReqStatus] = useState<string>("");
    const [showSuccess, setShowSuccess] = useState<boolean>(false);

    async function submitHandler() {
        if (reqStatus === 'in_prog') {
            return;
        }

        setReqStatus("in_prog");

        let res = await verifyTwitterFollower(twAnchor, getWalletAddress());

        if (res.status === 0) {
            setReqStatus("");
            setShowSuccess(true);
            //props.handleClose();

            if (props.afterSuccess) {
                props.afterSuccess(res, twAnchor);
            }
        }
        else {
            setReqStatus("error");
        }
    }

    useEffect(() => {
        if (props.open === false) {
            setTwAnchor("");
        }
    }, [props.open])

    //
    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">

            <Box sx={{
                display: "flex",
                flexDirection: "column",
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: 300,
                minWidth: 250,
                bgcolor: '#ffffff;',
                borderRadius: 3,
                boxShadow: 24,
                justifyContent: "center",
                alignItems: "center",
                outline: "none",
                overflow: "hidden"
            }}>
                <Box style={{ background: "#1d9bf1", borderBottom: "1px solid #bedbef", display: "flex", width: "100%", padding: "15px 20px 10px 20px", justifyContent: "space-between", alignItems: "center", lineHeight: 1 }}>
                    <Box style={{ fontSize: 16, fontWeight: 700, whiteSpace: "nowrap", color: "white" }}>Twitter Verification</Box>
                    <CloseIcon onClick={props.handleClose} sx={{ cursor: 'pointer', color: "#eeeeee", "&:hover": { color: "#ffffff" } }} />
                </Box>

                {!showSuccess && <Box style={{ padding: "20px" }}>
                    <Box style={{ textAlign: "center", fontSize: 15, fontWeight: 400, color: "#555555", paddingTop: 5, lineHeight: 1.2 }}>In order to complete the quest, please follow below steps:</Box>

                    <Box>
                        <Box style={{ marginBottom: "20px", marginTop: "20px", fontSize: 15, lineHeight: 1.2 }}>
                            <Box>
                                1. Follow <a target="_blank" rel="noreferrer" style={{ color: "blue", textDecoration: "underline" }} href="https://twitter.com/EternalDragons_">Eternal Dragons</a> on Twittter
                            </Box>
                        </Box>

                        <Box style={{ marginBottom: "25px", fontSize: 15 }}>
                            <Box style={{ marginBottom: "10px" }}>
                                2. Enter your Twitter username
                            </Box>

                            <Box style={{ marginTop: "10px" }}>
                                <TextField
                                    variant="outlined"
                                    label="username"
                                    onChange={(event) => setTwAnchor(event.target.value)}
                                    value={twAnchor}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <TwitterIcon sx={{ color: "#1d9bf1" }} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                        </Box>

                        <Box style={{ marginBottom: "10px" }}>
                            <Box style={{ textAlign: "center" }}>
                                <Button
                                    disabled={twAnchor.trim() === ""}
                                    sx={{ color: "white", fontWeight: 700, background: "#1d9bf1!important", "&.Mui-disabled": { background: "grey!important" } }}
                                    variant="contained"
                                    type="submit"
                                    onClick={submitHandler}>

                                    {reqStatus === 'in_prog' && <CircularProgress size={15} sx={{ marginRight: "10px" }} />}
                                    Submit
                                </Button>
                            </Box>
                        </Box>

                        {reqStatus === 'error' &&
                            <Box style={{ color: "red", textAlign: "center", marginTop: "20px" }}>
                                Error
                            </Box>}
                    </Box>
                </Box>}

                {showSuccess && <Box style={{ padding: "20px" }}>
                    <Box style={{ textAlign: "center", fontSize: 17, fontWeight: 400, color: "#0a9e51", padding: "5px 5px 15px 5px", lineHeight: 1.2 }}>Twitter verification finished successfully.</Box>
                </Box>}

            </Box>
        </Modal>
    )
}
